// AuthLayout.jsx
import React from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import logoIcon from "../assets/logo192.png";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--color-bg)",
        padding: "1rem",
      }}
    >
      <motion.div
        variants={fadeUp}
        initial="initial"
        animate="animate"
        transition={{ duration: 0.5 }}
        style={{
          width: "100%",
          maxWidth: 420,
        }}
      >
        <div
          style={{
            background: "var(--color-bg-card)",
            borderRadius: 18,
            boxShadow: "var(--shadow-md)",
            border: "1px solid var(--color-border)",
            padding: "2rem",
          }}
        >
          {/* Logo */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
            <img
              src={logoIcon}
              alt="Versetal"
              onError={(e) => { e.target.style.display = "none"; }}
              style={{ height: 40, width: "auto", objectFit: "contain", borderRadius: 10 }}
            />
          </div>

          {/* Title */}
          <h2 className={`fw-bold text-center ${subtitle ? "mb-1" : "mb-4"}`} style={{ color: "var(--color-text)" }}>
            {title}
          </h2>
          {subtitle && (
            <p className="text-center mb-4" style={{ color: "var(--color-text-light)", fontSize: 13 }}>
              {subtitle}
            </p>
          )}

          {children}
        </div>
      </motion.div>
    </div>
  );
}
